/**
 * Skeleton loading components for consistent loading states
 */

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div className={`card animate-pulse ${className}`}>
      <div className="h-4 bg-border rounded w-1/3 mb-3" />
      <div className="h-8 bg-border rounded w-1/2 mb-2" />
      <div className="h-3 bg-border rounded w-1/4" />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="animate-pulse py-3 flex items-center justify-between">
      <div className="flex-1">
        <div className="h-4 bg-border rounded w-1/3 mb-2" />
        <div className="h-3 bg-border rounded w-1/2" />
      </div>
      <div className="h-6 bg-border rounded w-16" />
    </div>
  );
}

export function SkeletonList({ count = 5 }: { count?: number }) {
  return (
    <div className="card divide-y divide-border">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  );
}

export function SkeletonGrid({ count = 4 }: { count?: number }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
